export interface ApiError {
  code: string;
  message: string;
  /**
   * Payload estruturado do erro (docs/error-contract.md). É por ele que uma
   * tela monta mensagem específica e traduzida — o interceptor de
   * services/api.js manda ler `apiError.details`, e até #1855 este campo era
   * descartado aqui, então essa leitura sempre dava `undefined`.
   */
  details?: Record<string, unknown>;
  correlationId?: string;
}

export const parseError = (
  response?: { data?: any; statusText?: string },
): ApiError => {
  const data = response?.data ?? {};
  return {
    code: data.code ?? 'UNKNOWN',
    message: data.message ?? response?.statusText ?? 'Unknown error',
    details: data.details,
    correlationId: data.correlationId,
  };
};

export default parseError;
